import { render } from "./AccessRequestList.vue?vue&type=template&id=c6c9e5d2"
import script from "./AccessRequestList.vue?vue&type=script&lang=js"
export * from "./AccessRequestList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__